const stylesheetUrl = "//fellowproducts.com/cdn/shop/t/1188/assets/subscriptions-account.css?v=67678832960776238581767136377";
const subscriptionDataUrl = "/account?view=subscription-data"

const REVEAL_DAYS = 3

// Takes in date in the format of "2022-11-18" and returns a boolean
// True if today is REVEAL_DAYS (3) days or less away from the target date
function inDateRange(dateString) {
  const today = new Date();
  const parsed = Date.parse(dateString)

  const diffInMs   = Math.abs(new Date(parsed) - today)
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24)
  const roundedDiff = Math.ceil(diffInDays)

  return roundedDiff >= 0 && roundedDiff <= REVEAL_DAYS
}

function isAppProxyPage() {
  return window.location.pathname.includes("tools/recurring")
}
class SubscriptionsPage {
  constructor () {
    this.loadCSS()

    this.subscriptions = this.getSubscriptionData()

    if(this._isSubscriptionsPage) {
      this.formatSubscriptionsPage()
    } else if (this._isSubscriptionsSinglePage) {
      this.formatSinglePage()
    } else if(this._isLoginPage) {
      this.formatLoginPage()
    }
  }

  get _isSubscriptionsPage() {
    return window.location.pathname.split("/").filter(n => n).pop() === "subscriptions"
  }

  get _isSubscriptionsSinglePage() {
    return window.location.pathname.split("/").reverse()[1] === "subscriptions"
  }

  get _isLoginPage() {
    return window.location.pathname.split("/").filter(n => n).pop() === "login"
  }

  loadCSS() {
    fetch(stylesheetUrl).then(res => {
      res.text().then(css => {
        $( `<style>${css}</style>` ).appendTo('body')
      })
    })
  }

  async getSubscriptionData() {
    const res = await fetch(subscriptionDataUrl)
    const data = await res.json();
    return data
  }

  async formatSubscriptionsPage() {
    const subscriptions = await this.subscriptions
    const sections = document.querySelectorAll('.rc_subscription_card_element_wrapper')
    const sectionsList = [...sections]

    sectionsList.forEach((section) => {
      const variant = section.querySelector('div.rc_schedule_wrapper > p:nth-child(3)').innerHTML.trim()
      const nextVariant = subscriptions.find(el => el.title === variant)

      if(nextVariant) {
        const dateWrapper = section.querySelector("[data-next-date]")
        const date = dateWrapper.getAttribute("data-next-date")
        const node = document.createElement('div');
        node.classList.add("recharge-next-shipment") 

        const nextShipmentText = section.querySelector(".rc_subscription_next_charge_date > div > p")
        nextShipmentText.innerHTML = "Next Coffee Order"
        nextShipmentText.classList.add('recharge-index-card-next-coffee')

        const isDateReady = inDateRange(date)

        if(isDateReady) {
          const title = nextVariant.next.title
          const vendor = nextVariant.next.vendor

          node.innerHTML = `
            <p>Coffee: ${title}</p>
            <p>Roaster: ${vendor}</p>
            <p>Price: ${nextVariant.next.price}</p>
            `;
          dateWrapper.parentElement.appendChild(node)

          const img = section.querySelector("img")
          img.src = nextVariant.next.image
        } else {
          node.innerHTML = "<p>We’re choosing your next coffee! Keep an eye on your email for updates.</p>"
          dateWrapper.parentElement.appendChild(node)
          const img = section.querySelector("img")
          img.src = "//fellowproducts.com/cdn/shop/t/1188/assets/coffee-picking-image.png?v=101980284560703192841767136282"
        }

        const textWrapper = section.querySelector('.rc_schedule_wrapper')
        textWrapper.classList.add('recharge-index-card-details')

        const priceEl = section.querySelector("div.rc_schedule_wrapper > p.text-font-14")
        priceEl.classList.add("recharge-index-price-el")
        const price = nextVariant.title.includes('Premium') ? nextVariant.price_per_bag_premium : nextVariant.price_per_bag
        priceEl.innerHTML = price

        const variantNameEl = section.querySelector("div.rc_schedule_wrapper > p:nth-child(3)")
        variantNameEl.classList.add('hide')
      }

      const img = section.querySelector("img")
      img.style.visibility = 'visible'
    })

    document.querySelectorAll("h2.page-title").forEach(elm => {
      if(elm.innerHTML.includes("Inactive")) {
        elm.style.display = "none";
      }
    })
  }

  async formatSinglePage() {
    const subscriptions = await this.subscriptions

    const placeholderRoot = document.querySelector('.edit_subscription_info-product')
    const placeholder = placeholderRoot.querySelector('div.ml-5')
    if(!placeholder){
      return
    }
    const dateWrapper = document.querySelector("[data-next-date]")
    const date = dateWrapper.getAttribute("data-next-date")
    const variant = placeholder.querySelector('p').innerHTML
    const quantity = placeholder.querySelector('p:nth-child(3)').innerHTML.split(" ")[1]
    const nextVariant = subscriptions.find(el => el.title === variant)
    const title = nextVariant.next.title
    const vendor = nextVariant.next.vendor

    placeholder.classList.add("recharge-next-shipment-inner") 

    const isDateReady = inDateRange(date)

    const img = placeholderRoot.querySelector("img")

    if(isDateReady) {
      const innerHTML = `
        <p class="head">Next Coffee Order</p>
        <p>Coffee: ${title}</p>
        <p>Roaster: ${vendor}</p>
        <p>Bags per Shipment: ${quantity}</p>
        <p>Price: ${nextVariant.next.price}</p>
        `;
      placeholder.innerHTML = innerHTML
      img.src = nextVariant.next.image
    } else {
      placeholder.innerHTML = "<p>We’re choosing your next coffee! Keep an eye on your email for updates.</p>"
      img.src = "//fellowproducts.com/cdn/shop/t/1188/assets/coffee-picking-image.png?v=101980284560703192841767136282"
    }
   
    img.style.visibility = 'visible'

    const rightContent = document.querySelector('#rc_manage_subscription_container .right-content')

    rightContent.innerHTML = `
    <div class="recharge-next-shipment-button-wrapper">
      <button id="skip-next-btn">Skip next Shipment</button>
      <button id="cancel-sub-btn">Cancel Subscription</button>
    </div>
    `

    setTimeout(() => {
      document.querySelector('#skip-next-btn').addEventListener('click', () => {
        document.querySelector("button[data-type='skip']").click()
      })

      document.querySelector('#cancel-sub-btn').addEventListener('click', () => {
        document.querySelector("button[data-title='Cancel']").click()
      })
    })
  }

  async formatLoginPage() {
    const el = document.querySelector('#customer_tab_content .rc_header-settings__description p')
    if(!el) return

    const text = el.innerHTML

    if(text.includes("no subscription")) {
      el.innerHTML = "You don’t have any subscriptions… yet! Explore our delightful Coffee Subscriptions, curated to your taste."
    }

    const wrapperEl = document.querySelector("#customer_tab_content .row.grid > div")

    if(wrapperEl) {
      wrapperEl.style.flex = "1"
      wrapperEl.style.maxWidth = "100%"
    }

    // Fix .f being overridden by inject style
    document.head.insertAdjacentHTML("beforeend", `<style>.f { display:flex !important;</style>`)
  }
}


(function () {
  if(isAppProxyPage()) {
    new SubscriptionsPage()
  }
})();

